import { render, staticRenderFns } from "./BioSection.vue?vue&type=template&id=0a2c61f0&"
import script from "./BioSection.vue?vue&type=script&lang=js&"
export * from "./BioSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports